import styled from '@emotion/styled';
import { useSize } from 'ahooks';
import { Badge, Card } from 'antd';
import Empty from 'components/Empty';
import { initEcharts } from 'lib/echarts';
import { useEffect, useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { percentDisplay } from 'views/Dashboard/ImplementData/utils';
import CAheadButton from '../business/AheadButton';
import useDrawerContext from '../Trend/hooks/useDrawer';
import TitleLayout from '../Trend/TitleLayout';

const AheadButton = styled(CAheadButton)`
  margin-left: 14px;
`;
const Container = styled(Card)`
  .ant-card-body {
    display: flex;

    .legend {
      width: 25%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      justify-content: center;
      .ant-badge {
        color: var(--fett-text-tertiary);
      }
      .num {
        color: var(--fett-text-secondary);
        font-size: 16px;
        margin-left: 14px;
        font-weight: 500;
      }
    }
  }
`;

const Relative = styled.div`
  position: relative;
  width: 75%;
  .ant-empty {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .chatEl {
    height: 100%;
    width: 100%;
  }
`;
interface Props {
  value?: Dashboard.ReviewInner;
}
const BuyerComment = (props: Props) => {
  const { value } = props;
  const { t } = useTranslate();
  const chartDomRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<echarts.ECharts>();
  const { width } = useSize(chartDomRef) || {};
  useEffect(() => {
    chartRef.current?.resize();
  }, [width]);
  useEffect(() => {
    if (!value || !chartDomRef.current) {
      return;
    }
    if (!chartRef.current) {
      chartRef.current = initEcharts(chartDomRef.current);
    }
    chartRef.current.setOption({
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          label: {
            formatter: '{b}: {c}',
            color: 'var(--fett-text-primary)',
            textBorderColor: 'transparent',
            textBorderWidth: 0,
          },
          data: [
            {
              value: value.中差评,
              name: t('ViewDashboard.中差评'),
              itemStyle: {
                color: ' #5b8ff9',
                opacity: 0.85,
              },
              label: {
                overflow: 'break',
              },
            },
            {
              value: value.好评,
              name: t('ViewDashboard.好评'),
              itemStyle: {
                color: '#5AD8A6',
                opacity: 0.85,
              },
              label: {
                overflow: 'break',
              },
            },
          ],
        },
      ],
    });
  }, [value, t]);
  const showEmpty = !value?.中差评 && !value?.好评;
  const { setTrendValue } = useDrawerContext();

  return (
    <Container
      title={
        <TitleLayout performanceName="BAD_COMMENT_RATE">
          <div>
            <span className="before" />
            {t('ViewDashboard.买家评价')}
          </div>
        </TitleLayout>
      }
    >
      <Relative>
        <div
          ref={chartDomRef}
          className="chatEl"
          style={{ display: showEmpty ? 'none' : 'block' }}
        />
        {showEmpty ? <Empty /> : null}
      </Relative>
      <div className="legend">
        <div className="item">
          <div className="title">
            <Badge color="#6195FA" text={t('ViewDashboard.中差评订单率')} />
          </div>
          <div className="num">{percentDisplay(value?.中差评订单率)}</div>
          <AheadButton
            rate={value?.买家评价领先率 ?? 0}
            onClick={() => {
              setTrendValue({
                type: 'rank',
                params: { performanceName: 'BAD_COMMENT_RATE' },
                visible: true,
              });
            }}
          />
        </div>
        <div className="item">
          <div className="title">
            <Badge color="#61DAAB" text={t('ViewDashboard.好评订单率')} />
          </div>
          <div className="num">{percentDisplay(value?.好评订单率)}</div>
        </div>
      </div>
    </Container>
  );
};

export default BuyerComment;
